import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
    DialogContentText
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ConfirmInfo from "../../../assets/icons/confirm-info.svg";
import "./confirm-dialog.scss";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: string;
    confirmText?: string;
    cancelText?: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    description,
    confirmText = "Confirm",
    cancelText = "Cancel",
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: "400px",
                        borderRadius: "15px",
                        overflowY: "inherit",
                        paddingBottom: "30px",
                    },
                },
            }}
            className="confirm-dialog"
        >
            <div className="delete-dialog-header">
                <div className="header-icon-and-title">
                    <img src={ConfirmInfo} alt="Alert" className="alert-icon" />
                    <Typography variant="h6" className="dialog-title">
                        {title}
                    </Typography>
                </div>
                <CloseIcon onClick={onClose} className="close-icon" />
            </div>
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-dialog-actions">
                <Button
                    variant="outlined"
                    onClick={onClose}
                    className="confirm-dialog-button left cancel-button"
                >
                    {cancelText}
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    className="confirm-dialog-button right"
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;